import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalstage2.b2clogin.com/tfp/mncportalstage2.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  commonDomainEmailNoteReleaseDate: '2025-09-01T00:00:00Z',
  b2cPolicies: b2cPolicies,
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://usermgmt.portalstg2.mynexuscare.com/',
  apiUrl: 'https://api-homehealth.portalstg2.mynexuscare.com',
  platformApiUrl: 'https://api-platform.portalstg2.mynexuscare.com',
  registryUrl: `https://api-platform.portalstg2.mynexuscare.com/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: 'dee9264f-976c-470c-8bca-816fe67ddbdc',
        postLogoutRedirectUri: 'https://usermgmt.portalstg2.mynexuscare.com/login',
        redirectUri: 'https://usermgmt.portalstg2.mynexuscare.com/login',
        knownAuthorities: ['mncportalstage2.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportalstage2.onmicrosoft.com/api/api.Write',
        'https://mncportalstage2.onmicrosoft.com/api/api.Read',
        'https://mncportalstage2.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://api-homehealth.portalstg2.mynexuscare.com/',
          [
            'https://mncportalstage2.onmicrosoft.com/api/api.Write',
            'https://mncportalstage2.onmicrosoft.com/api/api.Read',
            'https://mncportalstage2.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-platform.portalstg2.mynexuscare.com/',
          [
            'https://mncportalstage2.onmicrosoft.com/api/api.Write',
            'https://mncportalstage2.onmicrosoft.com/api/api.Read',
            'https://mncportalstage2.onmicrosoft.com/api/user_impersonation',
          ]
        ]
      ]
    }
  }
};
